import * as ambassadorWixAcademyCertificationsV1AccountCertification from './academy-certifications-v1-account-certification-account-certifications.http.js';
import * as ambassadorWixAcademyCertificationsV1AccountCertificationTypes from './academy-certifications-v1-account-certification-account-certifications.types.js';
import * as ambassadorWixAcademyCertificationsV1AccountCertificationUniversalTypes from './academy-certifications-v1-account-certification-account-certifications.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function queryAccountCertifications(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAcademyCertificationsV1AccountCertificationUniversalTypes.QueryAccountCertificationsRequest,
  ambassadorWixAcademyCertificationsV1AccountCertificationTypes.QueryAccountCertificationsRequest,
  ambassadorWixAcademyCertificationsV1AccountCertificationUniversalTypes.QueryAccountCertificationsResponse,
  ambassadorWixAcademyCertificationsV1AccountCertificationTypes.QueryAccountCertificationsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAcademyCertificationsV1AccountCertification.queryAccountCertifications(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/account-certifications/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listAccountCertifications(): __PublicMethodMetaInfo<
  'GET',
  { accountId: string },
  ambassadorWixAcademyCertificationsV1AccountCertificationUniversalTypes.ListAccountCertificationsRequest,
  ambassadorWixAcademyCertificationsV1AccountCertificationTypes.ListAccountCertificationsRequest,
  ambassadorWixAcademyCertificationsV1AccountCertificationUniversalTypes.ListAccountCertificationsResponse,
  ambassadorWixAcademyCertificationsV1AccountCertificationTypes.ListAccountCertificationsResponse
> {
  const payload = { accountId: ':accountId' } as any;

  const getRequestOptions =
    ambassadorWixAcademyCertificationsV1AccountCertification.listAccountCertifications(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/account-certifications/by-account/{accountId}',
    pathParams: { accountId: 'accountId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  AccountCertification as AccountCertificationOriginal,
  CertificationType as CertificationTypeOriginal,
  CertificationTypeWithLiterals as CertificationTypeWithLiteralsOriginal,
  CertifyAccountRequest as CertifyAccountRequestOriginal,
  CertifyAccountResponse as CertifyAccountResponseOriginal,
  DecertifyAccountRequest as DecertifyAccountRequestOriginal,
  DecertifyAccountResponse as DecertifyAccountResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  QueryAccountCertificationsRequest as QueryAccountCertificationsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryAccountCertificationsResponse as QueryAccountCertificationsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  ListAccountCertificationsRequest as ListAccountCertificationsRequestOriginal,
  ListAccountCertificationsResponse as ListAccountCertificationsResponseOriginal,
  Certification as CertificationOriginal,
  TeamMemberRemovedEvent as TeamMemberRemovedEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './academy-certifications-v1-account-certification-account-certifications.types.js';
